import { Divider } from "primereact/divider";
import SignatureBox from "../../../../components/signature-box/SignatureBox";

const EditorSignatureSection = ({
  headerData,
  isBerangkat,
  verifSettingPengecekan,
  pengecekanBerangkatData,
  pengecekanKembaliData,
  handleOnSignDicekStaffBerangkat,
  handleOnSignDicekKeamananBerangkat,
  handleOnSignDicekStaffKembali,
  handleOnSignDicekKeamananKembali,
  onValidateStaffBerangkat,
  onValidateKeamananBerangkat,
  onValidateStaffKembali,
  onValidateKeamananKembali,
}) => {
  return (
    <div className="col-start-start w-full gap-4">
      <div
        className={`elevated-card bottom-4 !px-5 !py-2 w-full row-around-start gap-0 `}
      >
        <SignatureBox
          disabled={(headerData.id ? false : true) || !isBerangkat}
          label="Diketahui (berangkat)"
          title=" TRANSPORT"
          fieldId="verif_staff_id"
          fieldData="data_verif_staff"
          fieldDatetime="verif_staff_datetime"
          verifField="pengecekan_mobil:staff"
          jabatanId={verifSettingPengecekan.jabatan_id}
          jabatanIdRequirement={verifSettingPengecekan["staff"]}
          field="verif_staff_id"
          data={pengecekanBerangkatData}
          onConfirm={handleOnSignDicekStaffBerangkat}
          bgColor={"bg-emerald-100"}
          color={"bg-emerald-600"}
          onValidate={onValidateStaffBerangkat}
        />
        <Divider className="h-[10rem] mx-3" layout="vertical" />
        <SignatureBox
          disabled={(headerData.id ? false : true) || !isBerangkat}
          label="dicek (berangkat)"
          title="KEAMANAN"
          fieldId="verif_keamanan_id"
          fieldData="data_verif_keamanan"
          fieldDatetime="verif_keamanan_datetime"
          verifField="berangkat:keamanan"
          jabatanId={verifSettingPengecekan.jabatan_id}
          jabatanIdRequirement={verifSettingPengecekan["keamanan"]}
          field="verif_keamanan_id"
          data={pengecekanBerangkatData}
          onConfirm={handleOnSignDicekKeamananBerangkat}
          onValidate={onValidateKeamananBerangkat}
        />
      </div>
      <div
        className={`elevated-card bottom-4 !px-5 !py-2 w-full row-around-start gap-0 `}
      >
        <SignatureBox
          disabled={(headerData.id ? false : true) || isBerangkat}
          label="Diketahui (kembali)"
          title="TRANSPORT"
          fieldId="verif_staff_id"
          fieldData="data_verif_staff"
          fieldDatetime="verif_staff_datetime"
          verifField="pengecekan_mobil:staff"
          jabatanId={verifSettingPengecekan.jabatan_id}
          jabatanIdRequirement={verifSettingPengecekan["staff"]}
          field="verif_staff_id"
          data={pengecekanKembaliData}
          onConfirm={handleOnSignDicekStaffKembali}
          bgColor={"bg-emerald-100"}
          color={"bg-emerald-600"}
          onValidate={onValidateStaffKembali}
        />
        <Divider className="h-[10rem] mx-3" layout="vertical" />
        <SignatureBox
          disabled={(headerData.id ? false : true) || isBerangkat}
          label="dicek (kembali)"
          title="KEAMANAN"
          fieldId="verif_keamanan_id"
          fieldData="data_verif_keamanan"
          fieldDatetime="verif_keamanan_datetime"
          verifField="pengecekan_mobil:keamanan"
          jabatanId={verifSettingPengecekan.jabatan_id}
          jabatanIdRequirement={verifSettingPengecekan["keamanan"]}
          field="verif_keamanan_id"
          data={pengecekanKembaliData}
          onConfirm={handleOnSignDicekKeamananKembali}
          onValidate={onValidateKeamananKembali}
        />
      </div>
    </div>
  );
};

export default EditorSignatureSection;
